export const generateFallbackAvatar = (name: string, size: number = 64) =>
	`https://ui-avatars.com/api/?name=${encodeURIComponent(
		name || "User"
	)}&background=0284c7&color=fff&size=${size}`;

export const stripHtmlTags = (html: string): string => {
	if (!html) return "";

	try {
		// Use DOM parser for more reliable HTML stripping
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");

		// Remove script and style elements
		doc.querySelectorAll("script, style").forEach((el) => el.remove());

		// Get text content
		const textContent = doc.body.textContent || doc.body.innerText || "";

		// Clean up whitespace
		const result = textContent.replace(/\s+/g, " ").trim();
		return result;
	} catch (error) {
		// Fallback to regex if DOM parser fails
		console.warn("DOM parser failed, using regex fallback:", error);
		const result = html
			.replace(/<[^>]*>/g, "")
			.replace(/&nbsp;/g, " ")
			.replace(/&amp;/g, "&")
			.replace(/&lt;/g, "<")
			.replace(/&gt;/g, ">")
			.replace(/&quot;/g, '"')
			.replace(/&#39;/g, "'")
			.replace(/\s+/g, " ")
			.trim();
		return result;
	}
};

export const truncateText = (text: string, maxLength: number = 200): string => {
	// First strip HTML tags to get clean text
	const cleanText = stripHtmlTags(text);

	if (cleanText.length <= maxLength) return cleanText;
	return cleanText.substring(0, maxLength) + "...";
};
